module.exports = __webpack_public_path__ + "assets/img/gwc.f7d8493b.png";